<template>
    <AppHeader fixed>
      <SidebarToggler mobile class="d-lg-none" display="md" /><!-- display="md" mobile-->
      <b-link class="navbar-brand" to="#">
        {{ brand.label }}
        <!--
        <img class="navbar-brand-full" src="img/brand/logo.svg" width="89" height="25" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/sygnet.svg" width="30" height="30" alt="CoreUI Logo">
        -->
      </b-link>
      <SidebarToggler class="d-md-down-none" :defaultOpen="true" display="lg" /><!---->
      <!--
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>
      </b-navbar-nav>
      -->
      <breadcrumbs v-if="breadcrumbs" :items="breadcrumbs" class="d-md-down-none"></breadcrumbs>
      <b-navbar-nav class="ml-auto">
        <!--
        <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>
        -->
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!--
      <AsideToggler class="d-none d-lg-block" />
      <AsideToggler class="d-lg-none" mobile />
      -->
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
//import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import env from 'environment';

export default {
  name: 'DefaultHeader',
  components: {
    AsideToggler,
    AppHeader,
    //DefaultHeaderDropdownAccnt,
    SidebarToggler
  },
  props: {
    breadcrumbs: {
      type: Array
    },
  },
  created() {
    this.brand = env.brand;
  }
}
</script>
